webpackJsonp([40],{

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/customers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  syncAuth: function syncAuth(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/sync', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[(_vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.createItem()}}},[_c('span',[_vm._v("+")]),_vm._v(" Create New\n              ")]):_vm._e(),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Company Name, Phone or Email"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n                  Company\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('company.name')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("\n                  Customer\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('fullName')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("Phone")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.companyName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title)+". "+_vm._s(item.fullName))]),_vm._v(" "),_c('td',[_c('span',{class:{ 'sts-danger': item.phones.length === 0 }},[_vm._v(_vm._s(_vm.printPhone(item.phones)))])]),_vm._v(" "),_c('td',[_c('span',{class:{ 'sts-danger': item.emails.length === 0 }},[_vm._v(_vm._s(_vm.printEmail(item.emails)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                  Corp. "+_vm._s(item.isAdmin ? "Admin" : "Booker")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateItem(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e(),_vm._v(" "),(!item.isSync && _vm.isAllowToSync)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.openAuthModal(item)}}},[_c('span',[_vm._v("Sync")])]):_vm._e()])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"customermodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Customer")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mt-5"},[_c('ul',{staticClass:"nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'general' ? 'active' : '']},[_c('a',{attrs:{"href":"#customer-general","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'general'}}},[_c('span',{staticClass:"required"},[_vm._v("General")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'contact' ? 'active' : '']},[_c('a',{attrs:{"href":"#customer-contact","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'contact'}}},[_c('span',{staticClass:"required"},[_vm._v("Contact")])])])]),_vm._v(" "),(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'general' ? 'in active' : ''],attrs:{"id":"customer-general"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},_vm._l((_vm.titles),function(item,index){return _c('label',{key:index,staticClass:"btn",class:{
                              active: _vm.model.title === item.value,
                              'field-error':
                                _vm.isSubmitted && _vm.$v.model.title.$error,
                            },on:{"click":function($event){_vm.model.title = item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],attrs:{"type":"radio","name":"title","autocomplete":"off"},domProps:{"value":item.value,"checked":_vm.model.title === item.value,"checked":_vm._q(_vm.model.title,item.value)},on:{"change":function($event){return _vm.$set(_vm.model, "title", item.value)}}}),_vm._v("\n                            "+_vm._s(item.text)+"\n                          ")])}),0),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.title.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Title is required")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.companyId.$error,
                          },attrs:{"placeholder":"","label":"name","options":_vm.companies,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.model.companyId),callback:function ($$v) {_vm.$set(_vm.model, "companyId", $$v)},expression:"model.companyId"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.companyId.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Company is required")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fullName),expression:"model.fullName"}],staticClass:"form-control alphabets-only",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.fullName.$error,
                          },attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.model.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "fullName", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.fullName.$error)?_c('div',[(!_vm.$v.model.fullName.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.fullName.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name must be less than\n                            "+_vm._s(_vm.$v.model.fullName.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.isUpdate)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.password.$error,
                          },attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.password.$error)?_c('div',[(!_vm.$v.model.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                            "+_vm._s(_vm.$v.model.password.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Is Admin?")]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isAdmin),expression:"model.isAdmin"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isAdminFlagNo","value":"false"},domProps:{"checked":_vm.model.isAdmin == false,"checked":_vm._q(_vm.model.isAdmin,"false")},on:{"change":function($event){return _vm.$set(_vm.model, "isAdmin", "false")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("No")])]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isAdmin),expression:"model.isAdmin"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isAdminFlagYes","value":"true"},domProps:{"checked":_vm.model.isAdmin == true,"checked":_vm._q(_vm.model.isAdmin,"true")},on:{"change":function($event){return _vm.$set(_vm.model, "isAdmin", "true")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Yes")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Is Person In Charge?")]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isPersonInCharge),expression:"model.isPersonInCharge"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isPersonInChargeNo","value":"false"},domProps:{"checked":_vm.model.isPersonInCharge == false,"checked":_vm._q(_vm.model.isPersonInCharge,"false")},on:{"change":function($event){return _vm.$set(_vm.model, "isPersonInCharge", "false")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("No")])]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isPersonInCharge),expression:"model.isPersonInCharge"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isPersonInChargeYes","value":"true"},domProps:{"checked":_vm.model.isPersonInCharge == true,"checked":_vm._q(_vm.model.isPersonInCharge,"true")},on:{"change":function($event){return _vm.$set(_vm.model, "isPersonInCharge", "true")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Yes")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Preferred Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.name),expression:"location.name"}],staticClass:"form-control",attrs:{"type":"text","name":"location_name","autocomplete":"off"},domProps:{"value":(_vm.location.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.address),expression:"location.address"}],staticClass:"form-control",attrs:{"rows":"4","name":"location_address","autocomplete":"off"},domProps:{"value":(_vm.location.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "address", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","id":"btn-map"},on:{"click":function($event){$event.preventDefault();return _vm.openMapModal()}}},[_c('i',{staticClass:"ic-map"}),_vm._v("\n                        Select Location by Map\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'contact' ? 'in active' : ''],attrs:{"id":"customer-contact"}},[_c('div',[_c('h4',[_vm._v("Phone")]),_vm._v(" "),_vm._l((_vm.model.modifiedPhones),function(item,index){return _c('div',{key:index,staticClass:"row"},[(item.state !== 'Deleted')?_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",class:{
                                        'field-error':
                                          _vm.isSubmitted &&
                                          _vm.$v.model.modifiedPhones.$each[index]
                                            .code.$error,
                                      },attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; }},on:{"input":function($event){return _vm.onChangeCustomerItem(item)}},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                            "+_vm._s(option.country)+"\n                                          ")])])]}}],null,true),model:{value:(item.code),callback:function ($$v) {_vm.$set(item, "code", $$v)},expression:"item.code"}}),_vm._v(" "),(
                                        _vm.isSubmitted &&
                                        !_vm.$v.model.modifiedPhones.$each[index]
                                          .code.required
                                      )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Code is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.number),expression:"item.number"}],staticClass:"form-control numbers-only",class:{
                                        'field-error':
                                          _vm.isSubmitted &&
                                          _vm.$v.model.modifiedPhones.$each[index]
                                            .number.$error,
                                      },attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(item.number)},on:{"keyup":function($event){return _vm.onChangeCustomerItem(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "number", $event.target.value)}}}),_vm._v(" "),(
                                        _vm.isSubmitted &&
                                        _vm.$v.model.modifiedPhones.$each[index]
                                          .number.$error
                                      )?_c('div',[(
                                          !_vm.$v.model.modifiedPhones.$each[
                                            index
                                          ].number.required
                                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number is required")]):_vm._e(),_vm._v(" "),(
                                          !_vm.$v.model.modifiedPhones.$each[
                                            index
                                          ].number.maxLength
                                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number must be less than\n                                        "+_vm._s(_vm.$v.model.modifiedPhones.$each[index]
                                            .number.$params.maxLength.max)+"\n                                        characters")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[(
                                        _vm.model.modifiedPhones &&
                                        _vm.model.modifiedPhones.length > 0
                                      )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removePhone(index)}}},[_vm._v("\n                                      Remove\n                                    ")]):_vm._e()])])])])]):_vm._e()])}),_vm._v(" "),(_vm.phoneCodes && _vm.model.modifiedPhones)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.model.modifiedPhones)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addPhone()}}},[_vm._v("\n                              Add\n                            ")]):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"20px"}},[_c('h4',[_vm._v("Email")]),_vm._v(" "),_vm._l((_vm.model.modifiedEmails),function(item,index){return _c('div',{key:index,staticClass:"row"},[(item.state !== 'Deleted')?_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.email),expression:"item.email"}],staticClass:"form-control",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.modifiedEmails.$each[index]
                                        .email.$error,
                                  },attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(item.email)},on:{"keyup":function($event){return _vm.onChangeCustomerItem(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "email", $event.target.value)}}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    _vm.$v.model.modifiedEmails.$each[index].email
                                      .$error
                                  )?_c('div',[(
                                      !_vm.$v.model.modifiedEmails.$each[index]
                                        .email.required
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is required")]):_vm._e(),_vm._v(" "),(
                                      !_vm.$v.model.modifiedEmails.$each[index]
                                        .email.email
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is invalid")]):_vm._e(),_vm._v(" "),(
                                      !_vm.$v.model.modifiedEmails.$each[index]
                                        .email.maxLength
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email must be less than\n                                    "+_vm._s(_vm.$v.model.modifiedEmails.$each[index]
                                        .email.$params.maxLength.max)+"\n                                    characters")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[(
                                    _vm.model.modifiedEmails &&
                                    _vm.model.modifiedEmails.length > 0
                                  )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeEmail(index)}}},[_vm._v("\n                                  Remove\n                                ")]):_vm._e()])])]):_vm._e()])}),_vm._v(" "),(_vm.model.modifiedEmails)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addEmail()}}},[_vm._v("\n                              Add\n                            ")])])]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      "+_vm._s(_vm.isUpdate ? "Save Changes" : "Save")+"\n                    ")])])])])])])])])])]),_vm._v(" "),_c('div',{ref:"customerpasswordmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitAuth()}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.auth.password),expression:"auth.password"}],staticClass:"form-control",class:{
                        'field-error': _vm.isSubmitted && _vm.$v.auth.password.$error,
                      },attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.auth.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.auth, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.auth.password.$error)?_c('div',[(!_vm.$v.auth.password.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.auth.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                        "+_vm._s(_vm.$v.auth.password.$params.maxLength.max)+"\n                        characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(4)])])])])])])])]),_vm._v(" "),_c('div',{ref:"mapmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Customer Location")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n              Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n            ")]):_vm._e()]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Corporate")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Customer\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  Customer "),_c('span',[_c('i',{staticClass:"ic-office"})])]),_vm._v(" "),_c('p',[_vm._v("Manage your customers and booker details.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Customer Authentication")]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      Save Password\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"gmap-wrapper"},[_c('div',{staticClass:"pac-card",attrs:{"id":"pac-card"}},[_c('div',{attrs:{"id":"pac-container"}},[_c('input',{attrs:{"id":"pac-input","type":"text","placeholder":"Enter a location"}})])]),_vm._v(" "),_c('div',{attrs:{"id":"map"}}),_vm._v(" "),_c('div',{staticClass:"modal-footer text-center"},[_c('div',{attrs:{"id":"gmap-custom-control"}},[_c('button',{staticClass:"btn btn-default remove-location",attrs:{"type":"button"}},[_vm._v("\n                  Reset\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary save-location",attrs:{"type":"button"}},[_vm._v("\n                  Apply\n                ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__ = __webpack_require__(754);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8cd81f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__ = __webpack_require__(1014);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8cd81f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(462));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    cancel: function cancel() {
      $("#deletemodal").modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#deletemodal").modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(461));

var _alphaNum = _interopRequireDefault(__webpack_require__(464));

var _numeric = _interopRequireDefault(__webpack_require__(465));

var _between = _interopRequireDefault(__webpack_require__(466));

var _email = _interopRequireDefault(__webpack_require__(467));

var _ipAddress = _interopRequireDefault(__webpack_require__(468));

var _macAddress = _interopRequireDefault(__webpack_require__(469));

var _maxLength = _interopRequireDefault(__webpack_require__(470));

var _minLength = _interopRequireDefault(__webpack_require__(471));

var _required = _interopRequireDefault(__webpack_require__(472));

var _requiredIf = _interopRequireDefault(__webpack_require__(473));

var _requiredUnless = _interopRequireDefault(__webpack_require__(474));

var _sameAs = _interopRequireDefault(__webpack_require__(475));

var _url = _interopRequireDefault(__webpack_require__(476));

var _or = _interopRequireDefault(__webpack_require__(477));

var _and = _interopRequireDefault(__webpack_require__(478));

var _not = _interopRequireDefault(__webpack_require__(479));

var _minValue = _interopRequireDefault(__webpack_require__(480));

var _maxValue = _interopRequireDefault(__webpack_require__(481));

var _integer = _interopRequireDefault(__webpack_require__(482));

var _decimal = _interopRequireDefault(__webpack_require__(483));

var helpers = _interopRequireWildcard(__webpack_require__(458));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets.s3-ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(463).withParams : __webpack_require__(230).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6066_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(485);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6066_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":"deletemodal"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                Do you want to delete this record? This process cannot be\n                undone.\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/companies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var _canvas = void 0;
var _marker = void 0;
var _circle = void 0;
var _infoWindow = void 0;
var _hasAutocomplete = false;
var _hasMarker = false;
var _hasInfoWindow = false;
var _hasConfirmLocationCallback = false;
var _hasRemoveLocationCallback = false;
var _hasDrawGeometryCallback = false;
var _hasAutoCompleteGetPlaceCallback = false;
var _hasMarkerChangeCallback = false;
var _confirmLocationClassName = "save-location";
var _removeLocationClassName = "remove-location";
var _drawGeometryLocationClassName = "draw-geometry";

function _isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function _onClickCanvas(latLng) {
  _marker.setPosition(latLng);
  _marker.setVisible(true);
}

function _onPlaceChangedAutoComplete(autocomplete) {
  // hide marker
  if (_hasMarker) {
    _marker.setVisible(false);
  }

  var place = autocomplete.getPlace();
  if (!place.geometry) {
    // User entered the name of a Place that was not suggested and
    // pressed the Enter key, or the Place Details request failed.
    window.alert("No details available for input: '" + place.name + "'");
    return;
  }

  // If the place has a geometry, then present it on a map.
  if (place.geometry.viewport) {
    _canvas.fitBounds(place.geometry.viewport);
  } else {
    _canvas.setCenter(place.geometry.location);
  }

  _canvas.setZoom(15);

  // display marker
  if (_hasMarker) {
    _marker.setPosition(place.geometry.location);
    _marker.setVisible(true);
  }

  return place;
}

function _removeCircle() {
  if (_circle !== undefined) {
    _circle.setMap(null);
  }
}

function _removeInfoWindow() {
  if (_infoWindow !== undefined) {
    _infoWindow.close();
  }
}

function _initializeCircle(coordinate, visibleCircle) {
  // remove existing objects
  _removeCircle();
  _removeInfoWindow();

  // draw circle
  _circle = new google.maps.Circle({
    center: {
      lat: coordinate.lat,
      lng: coordinate.lng
    },
    radius: coordinate.rad,
    editable: true,
    draggable: true
  });

  // fill on canvas
  if (visibleCircle) {
    var showInfoWindow = function showInfoWindow() {
      var content = "Latitude: " + _circle.getCenter().lat() + "<br>" + "Longitude: " + _circle.getCenter().lng() + "<br>" + "Radius: " + _circle.getRadius().toString();

      // Set the info window's content and position.
      _infoWindow.setContent(content);
      _infoWindow.setPosition(_circle.getBounds().getNorthEast());
      _infoWindow.open(_canvas);
    };

    // attach listener


    _circle.setMap(_canvas);

    // create window
    _infoWindow = new google.maps.InfoWindow();

    _circle.addListener("radius_changed", showInfoWindow);
    _circle.addListener("center_changed", showInfoWindow);
  }
}

var MaverickMap = function () {
  function MaverickMap(config) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MaverickMap);

    // mapId: string
    // lat: double
    // lng: double
    // autocomplete: bool
    // marker: bool
    // infoWindow: bool
    // confirmLocationCallback: callback
    // removeLocationCallback: callback
    // drawGeometryCallback: callback
    // autoCompleteGetPlaceCallback: callback
    // markerChangeCallback: callback
    // confirmLocationClassName: string
    // removeLocationClassName: string
    // drawGeometryLocationClassName: string
    this.config = config;

    _hasAutocomplete = config.autocomplete !== undefined && config.autocomplete === true;
    _hasMarker = config.marker !== undefined && config.marker === true;
    _hasInfoWindow = config.infoWindow !== undefined && config.infoWindow === true;
    _hasConfirmLocationCallback = config.confirmLocationCallback !== undefined;
    _hasRemoveLocationCallback = config.removeLocationCallback !== undefined;
    _hasDrawGeometryCallback = config.drawGeometryCallback !== undefined;
    _hasAutoCompleteGetPlaceCallback = config.autoCompleteGetPlaceCallback !== undefined;
    _hasMarkerChangeCallback = config.markerChangeCallback !== undefined;
    _confirmLocationClassName = config.confirmLocationClassName !== config.confirmLocationClassName ? config.confirmLocationClassName : _confirmLocationClassName;
    _removeLocationClassName = config.removeLocationClassName !== config.removeLocationClassName ? config.removeLocationClassName : _removeLocationClassName;
    _drawGeometryLocationClassName = config.drawGeometryLocationClassName !== config.drawGeometryLocationClassName ? config.drawGeometryLocationClassName : _drawGeometryLocationClassName;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MaverickMap, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      // reset
      _canvas = undefined;
      _marker = undefined;
      _circle = undefined;
      _infoWindow = undefined;

      if (_isEmpty(this.config)) {
        return;
      }

      _canvas = new google.maps.Map(document.getElementById(this.config.mapId), {
        center: {
          lat: this.config.lat,
          lng: this.config.lng
        },
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      });

      _canvas.addListener("bounds_changed", function () {
        var container = document.getElementsByClassName("pac-container")[0];
        if (container !== undefined && container !== null) {
          container.setAttribute("style", "z-index: 2000;");
        }
      });

      // Marker
      if (_hasMarker) {
        _marker = new google.maps.Marker({
          map: _canvas,
          anchorPoint: new google.maps.Point(0, -29)
        });

        // attach event listener
        _canvas.addListener("click", function (e) {
          var latLng = e.latLng;
          _onClickCanvas(latLng);
          if (_hasMarkerChangeCallback) {
            _this.config.markerChangeCallback({
              lat: latLng.lat(),
              lng: latLng.lng()
            });
          }
        });
      }

      // Autocomplete
      if (_hasAutocomplete) {
        _canvas.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById("pac-card"));

        var autocomplete = new google.maps.places.Autocomplete(document.getElementById("pac-input"));

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo("bounds", _canvas);

        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(["address_components", "formatted_address", "geometry", "name", "place_id"]);

        // attach event listener
        autocomplete.addListener("place_changed", function (_) {
          var place = _onPlaceChangedAutoComplete(autocomplete);
          if (_hasAutoCompleteGetPlaceCallback) {
            _this.config.autoCompleteGetPlaceCallback(place);
          }
        });
      }

      var customControl = document.getElementById("gmap-custom-control");
      if (customControl) {
        // EventHandler: Save Location
        var saveLocationControl = customControl.getElementsByClassName(_confirmLocationClassName);
        if (_hasConfirmLocationCallback && saveLocationControl.length > 0) {
          saveLocationControl[0].addEventListener("click", function () {
            var coordinate = {};
            if (_marker !== undefined) {
              coordinate.lat = _marker.getPosition().lat();
              coordinate.lng = _marker.getPosition().lng();
            } else if (_circle !== undefined) {
              coordinate.lat = _circle.getCenter().lat();
              coordinate.lng = _circle.getCenter().lng();
              coordinate.rad = _circle.getRadius();
            }

            // callback
            _this.config.confirmLocationCallback(coordinate);
          });
        }

        // EventHandler: Remove Location
        var removeLocationControl = customControl.getElementsByClassName(_removeLocationClassName);
        if (_hasRemoveLocationCallback && removeLocationControl.length > 0) {
          removeLocationControl[0].addEventListener("click", function () {
            // remove objects
            _this.hideMarker();
            _removeCircle();
            _removeInfoWindow();

            // callback
            _this.config.removeLocationCallback();
          });
        }

        // EventHandler: Draw Geometry
        var drawGeometryControl = customControl.getElementsByClassName(_drawGeometryLocationClassName);
        if (_hasDrawGeometryCallback && drawGeometryControl.length > 0) {
          drawGeometryControl[0].addEventListener("click", function () {
            _initializeCircle({
              lat: _canvas.getCenter().lat(),
              lng: _canvas.getCenter().lng(),
              rad: 700
            }, true);
          });
        }
      }
    }
  }, {
    key: "showInfoWindow",
    value: function showInfoWindow(position, content) {
      if (_hasInfoWindow) {
        // initialize if empty
        if (_infoWindow === undefined) {
          _infoWindow = new google.maps.InfoWindow();
        }

        var latLng = new google.maps.LatLng(position.latitude, position.longitude);

        // Set the info window's content and position.
        _infoWindow.setContent(content);
        _infoWindow.setPosition(latLng);
        _infoWindow.open(_canvas);

        _canvas.setCenter(latLng);
        _canvas.setZoom(20);
      }
    }
  }, {
    key: "showMarker",
    value: function showMarker(center) {
      if (_hasMarker) {
        _marker.setPosition(center);
        _marker.setVisible(true);
      }
      _canvas.setCenter(center);
      _canvas.setZoom(15);
    }
  }, {
    key: "hideMarker",
    value: function hideMarker() {
      if (_hasMarker) {
        _marker.setVisible(false);
      }
      _canvas.setZoom(15);
    }
  }, {
    key: "setCircleCenter",
    value: function setCircleCenter(center, radius, visibleCircle) {
      if (_circle === undefined) {
        _initializeCircle({
          lat: center.lat(),
          lng: center.lng(),
          rad: radius
        }, visibleCircle);
      } else {
        _circle.setCenter(center);
        _circle.setRadius(radius);
      }
      _canvas.fitBounds(_circle.getBounds());
      _canvas.setZoom(12);
    }
  }, {
    key: "isInRadius",
    get: function get() {
      var result = false;
      if (_circle !== undefined) {
        result = google.maps.geometry.spherical.computeDistanceBetween(_marker.getPosition(), _circle.getCenter()) <= _circle.getRadius();
        if (!result) {
          _marker.setVisible(false);
        }
      }
      return result;
    }
  }]);

  return MaverickMap;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickMap);

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/countryPhones';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var _geocoder = void 0;

var MaverickGeocoding = function () {
  function MaverickGeocoding() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MaverickGeocoding);

    _geocoder = new google.maps.Geocoder();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MaverickGeocoding, [{
    key: 'geocode',
    value: function geocode(latLng) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _geocoder.geocode({
          location: latLng
        }, function (results, status) {
          if (status === "OK") {
            var result = results[0];
            var address = result.formatted_address;
            var name = '';
            if (result.address_components !== undefined && result.address_components !== null && result.address_components.length > 0) {
              var administrative_area_level_4 = '';
              var administrative_area_level_3 = '';
              var administrative_area_level_2 = '';
              var administrative_area_level_1 = '';
              var country = '';
              for (var index = 0; index < result.address_components.length; index++) {
                var addressComponent = result.address_components[index];
                if (addressComponent.types.includes('administrative_area_level_4')) {
                  administrative_area_level_4 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_3')) {
                  administrative_area_level_3 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_2')) {
                  administrative_area_level_2 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_1')) {
                  administrative_area_level_1 = addressComponent.long_name;
                } else if (addressComponent.types.includes('country')) {
                  country = addressComponent.long_name;
                }
              }
              if (administrative_area_level_4 !== '') {
                name = administrative_area_level_4;
              } else if (administrative_area_level_3 !== '') {
                name = administrative_area_level_3;
              } else if (administrative_area_level_2 !== '') {
                name = administrative_area_level_2;
              } else {
                name = address.split(',')[0];
              }

              // append city and country
              if (administrative_area_level_1 !== '' && country !== '') {
                name += ', ' + administrative_area_level_1 + ', ' + country;
              }
            }
            resolve({
              address: address,
              name: name,
              latitude: latLng.lat,
              longitude: latLng.lng
            });
          } else {
            reject();
          }
        });
      });
    }
  }]);

  return MaverickGeocoding;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickGeocoding);

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_company_companyService_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_master_customer_customerService_js__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_countryPhoneService_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_google_map_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_google_geocode_js__ = __webpack_require__(538);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSync: function isAllowToSync() {
      return this.allPermissions.includes("Sync");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    validationRulePassword: function validationRulePassword() {
      return !this.isUpdate ? { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) } : {};
    },
    validationRulePhone: function validationRulePhone() {
      return this.model.modifiedPhones && this.model.modifiedPhones.length > 0 ? {
        $each: {
          code: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
          number: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(20) }
        }
      } : {};
    },
    validationRuleEmail: function validationRuleEmail() {
      return this.model.modifiedEmails && this.model.modifiedEmails.length > 0 ? { $each: { email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) } } } : {};
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: ""
      },
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      allPermissions: [],
      itemToBeDeleted: null,
      map: null,
      geocoder: null,
      items: [],
      titles: [],
      companies: [],
      defaultCompanyId: null,
      phoneCodes: [],
      isMarkerChange: false,
      model: {},
      auth: {},
      location: { name: null, address: null, latitude: null, longitude: null },
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        title: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        companyId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        fullName: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(150) },
        password: this.validationRulePassword,
        modifiedPhones: this.validationRulePhone,
        modifiedEmails: this.validationRuleEmail
      },
      auth: {
        password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile, permissions, company;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              _this.publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(_this.publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 19;
                break;
              }

              _context.next = 13;
              return _this.getAll();

            case 13:
              _context.next = 15;
              return _this.getCompanies();

            case 15:
              _context.next = 17;
              return _this.getPhoneCodes();

            case 17:
              _this.titles = [{ value: "Mr", text: "Mr" }, { value: "Mrs", text: "Mrs" }, { value: "Ms", text: "Ms" }];

              if (profile.defaultCompany && _this.companies && _this.companies.length > 0) {
                company = _this.companies.find(function (x) {
                  return x.id == profile.defaultCompany.id;
                });

                if (company) {
                  _this.defaultCompanyId = company.id;
                }
              }

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    $(this.$refs.customermodal).on("hidden.bs.modal", this.closeCustomerModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);

    if (!this.map) {
      var defaultLatLng = this.$helper.extractSetting(this.publicSettings, "DefaultLatLng", "-6.17003832454938|106.81490242481232");
      var latLng = defaultLatLng.split("|");
      var lat = parseFloat(latLng[0]);
      var lng = parseFloat(latLng[1]);

      // creates map instance
      this.map = new __WEBPACK_IMPORTED_MODULE_8__plugins_google_map_js__["a" /* default */]({
        mapId: "map",
        lat: lat,
        lng: lng,
        marker: true,
        autocomplete: true,
        confirmLocationCallback: this.confirmLocation,
        removeLocationCallback: this.removeLocation,
        autoCompleteGetPlaceCallback: this.getPlace,
        markerChangeCallback: this.markerChange
      });
      this.map.initialize();
    }

    if (!this.geocoder) {
      // creates geocoder instance
      this.geocoder = new __WEBPACK_IMPORTED_MODULE_9__plugins_google_geocode_js__["a" /* default */]();
    }
  },
  updated: function updated() {
    // subscribe message
    this.$eventBus.$on("openCustomerDeleteModal", this.openCustomerDeleteModal);
    this.$helper.collapseMenu("corporate");
    this.$helper.setNavigationClass("customer-link");
    this.$helper.alphabetsOnly();
    this.$helper.numbersOnly();
    this.$helper.disableContextMenu(".readonly");
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("openCustomerDeleteModal");
    document.querySelectorAll(".pac-container").forEach(function (element) {
      return element.remove();
    });
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.table.pageNumber = 1;
                _context2.next = 3;
                return _this2.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this3;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this4.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    onClickSort: function onClickSort(column) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this5.table.sort === column) {
                  _this5.table.sortDir = _this5.table.sortDir === "asc" ? "desc" : "asc";
                } else {
                  _this5.table.sortDir = "asc";
                }
                _this5.table.sort = column;
                _context6.next = 4;
                return _this5.getAll();

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    confirmLocation: function confirmLocation(coordinate) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var geocodeResponse;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_this6.isMarkerChange) {
                  _context7.next = 5;
                  break;
                }

                _context7.next = 3;
                return _this6.geocoder.geocode(coordinate);

              case 3:
                geocodeResponse = _context7.sent;

                if (geocodeResponse !== undefined && geocodeResponse !== null) {
                  _this6.location.address = geocodeResponse.address;
                  _this6.location.name = geocodeResponse.name;
                  _this6.location.latitude = geocodeResponse.latitude;
                  _this6.location.longitude = geocodeResponse.longitude;
                }

              case 5:
                _this6.$notification.success("Location saved.", { title: "Success" });
                _this6.closeMapModal();

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    removeLocation: function removeLocation() {
      document.getElementById("pac-input").value = "";
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null
      };
      this.$notification.success("Location removed.", { title: "Success" });
    },
    getPlace: function getPlace(place) {
      // get place from autocomplete
      this.isMarkerChange = false;
      this.location.name = place.name;
      this.location.address = place.formatted_address;
      this.location.latitude = place.geometry.location.lat();
      this.location.longitude = place.geometry.location.lng();
    },
    markerChange: function markerChange(latLng) {
      this.isMarkerChange = true;
    },
    resetModel: function resetModel() {
      this.isMarkerChange = false;
      this.model = {};
      this.auth = {};
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null
      };
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.auth.$reset();
    },
    searchPhoneCode: function searchPhoneCode(options, search) {
      var pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter(function (item) {
        return pattern.test(item.area) || pattern.test(item.country) || pattern.test(item.dial) || pattern.test(item.iata);
      });
    },
    openCustomerModal: function openCustomerModal(item) {
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      if (this.model.addresses && this.model.addresses.length > 0) {
        this.location = this.model.addresses[0].location;
      }
      $(this.$refs.customermodal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    openMapModal: function openMapModal(item) {
      document.getElementById("pac-input").value = "";
      this.resetValidations();
      if (this.location !== null && this.location.latitude !== null && this.location.longitude !== null) {
        this.map.showMarker(new google.maps.LatLng(this.location.latitude, this.location.longitude));
      } else {
        this.map.hideMarker();
      }
      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeCustomerModal: function closeCustomerModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.customermodal).modal("hide");
    },
    closeMapModal: function closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      $(this.$refs.customermodal).css("overflow-y", "auto");
    },
    openCustomerDeleteModal: function openCustomerDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    openAuthModal: function openAuthModal(item) {
      this.resetValidations();
      this.auth = { id: item.id, password: null };
      $(this.$refs.customerpasswordmodal).modal();
    },
    closeAuthModal: function closeAuthModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.customerpasswordmodal).modal("hide");
    },
    submitAuth: function submitAuth() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this7.isSubmitted = true;
                _this7.$v.auth.$touch();

                if (!_this7.$v.auth.$error) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return");

              case 4:
                _context8.prev = 4;

                _this7.isLoading = true;
                _context8.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_customer_customerService_js__["a" /* default */].syncAuth(_this7.auth);

              case 8:
                _this7.$notification.success("Successfully synced.", {
                  title: "Success"
                });
                _this7.closeAuthModal();
                _context8.next = 12;
                return _this7.getAll();

              case 12:
                _context8.next = 17;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](4);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this7.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 17:
                _context8.prev = 17;

                _this7.isLoading = false;
                return _context8.finish(17);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7, [[4, 14, 17, 20]]);
      }))();
    },
    createItem: function createItem() {
      this.isUpdate = false;
      this.resetModel();
      this.activeTab = "general";
      this.openCustomerModal({
        companyId: this.defaultCompanyId,
        isAdmin: false,
        isPersonInCharge: false,
        title: null,
        addresses: [],
        modifiedEmails: [{
          id: this.$helper.emptyGuid(),
          email: null,
          isMain: false,
          state: "Created"
        }],
        modifiedPhones: [{
          id: this.$helper.emptyGuid(),
          code: null,
          number: null,
          isMain: false,
          state: "Created"
        }]
      });
    },
    updateItem: function updateItem(item) {
      this.isUpdate = true;
      this.activeTab = "general";
      item.modifiedEmails = [];
      item.modifiedPhones = [];
      this.openCustomerModal(item);
      for (var i = 0; i < this.model.emails.length; i++) {
        this.model.modifiedEmails.push({
          id: this.model.emails[i].id,
          email: this.model.emails[i].email,
          isMain: this.model.emails[i].isMain,
          state: "NoAction"
        });
      }
      for (var _i = 0; _i < this.model.phones.length; _i++) {
        this.model.modifiedPhones.push({
          id: this.model.phones[_i].id,
          code: this.model.phones[_i].code,
          number: this.model.phones[_i].number,
          isMain: this.model.phones[_i].isMain,
          state: "NoAction"
        });
      }
    },
    getAll: function getAll() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (_this8.isAllowToRead) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _context9.prev = 2;

                _this8.isLoading = true;
                filter = "?page=" + _this8.table.pageNumber + "&size=" + _this8.table.pageSize;

                if (_this8.table.keyword && _this8.table.keyword !== "") {
                  filter += "&search=" + _this8.table.keyword;
                }
                if (_this8.table.sort && _this8.table.sort !== "") {
                  filter += "&sort=" + _this8.table.sort + "&sortDir=" + _this8.table.sortDir;
                }
                _context9.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_customer_customerService_js__["a" /* default */].getAll(filter);

              case 9:
                response = _context9.sent;

                _this8.items = response.data;
                _this8.table.totalPages = response.totalPages;
                _this8.table.totalRecords = response.totalRecords;
                _context9.next = 18;
                break;

              case 15:
                _context9.prev = 15;
                _context9.t0 = _context9["catch"](2);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this8.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 18:
                _context9.prev = 18;

                _this8.isLoading = false;
                return _context9.finish(18);

              case 21:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8, [[2, 15, 18, 21]]);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 2:
                _this9.companies = _context10.sent;

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this9);
      }))();
    },
    getPhoneCodes: function getPhoneCodes() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_countryPhoneService_js__["a" /* default */].getAll();

              case 2:
                _this10.phoneCodes = _context11.sent;


                for (i = 0; i < _this10.phoneCodes.length; i++) {
                  item = _this10.phoneCodes[i];

                  item.label = item.iata + " (+" + item.dial + ")";
                  item.icon = "iti-flag " + item.iata.toLowerCase();
                }

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this10);
      }))();
    },
    submit: function submit() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this11.isSubmitted = true;
                _this11.$v.model.$touch();

                if (!_this11.$v.model.$error) {
                  _context12.next = 4;
                  break;
                }

                return _context12.abrupt("return");

              case 4:
                _context12.prev = 4;

                _this11.isLoading = true;
                _this11.model.addresses = [];
                if (_this11.location.address !== null && _this11.location.name !== null && _this11.location.latitude !== null && _this11.longitude !== null) {
                  _this11.model.addresses.push({
                    location: _this11.location,
                    isMain: true,
                    state: "Created"
                  });
                }
                _this11.model.isAdmin = _this11.model.isAdmin == "true" || _this11.model.isAdmin == true ? true : false;
                _this11.model.isPersonInCharge = _this11.model.isPersonInCharge == "true" || _this11.model.isPersonInCharge == true ? true : false;
                _this11.model.emails = _this11.model.modifiedEmails.map(function (x) {
                  return x;
                });
                _this11.model.phones = _this11.model.modifiedPhones.map(function (x) {
                  return x;
                });

                if (!_this11.isUpdate) {
                  _context12.next = 18;
                  break;
                }

                _context12.next = 15;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_customer_customerService_js__["a" /* default */].update(_this11.model);

              case 15:
                _this11.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context12.next = 21;
                break;

              case 18:
                _context12.next = 20;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_customer_customerService_js__["a" /* default */].create(_this11.model);

              case 20:
                _this11.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 21:
                _this11.closeCustomerModal();
                _context12.next = 24;
                return _this11.getAll();

              case 24:
                _context12.next = 29;
                break;

              case 26:
                _context12.prev = 26;
                _context12.t0 = _context12["catch"](4);

                if (_context12.t0.errors) {
                  for (index = 0; index < _context12.t0.errors.length; index++) {
                    _this11.$notification.error(_context12.t0.errors[index], { title: "Error" });
                  }
                }

              case 29:
                _context12.prev = 29;

                _this11.isLoading = false;
                return _context12.finish(29);

              case 32:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this11, [[4, 26, 29, 32]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                _this12.isLoading = true;
                _context13.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_customer_customerService_js__["a" /* default */].changeStatus({
                  id: item.id,
                  isActive: item.isActive
                });

              case 4:
                if (item.isActive) {
                  _this12.$notification.success("Successfully reactivated.", {
                    title: "Success"
                  });
                } else {
                  _this12.$notification.success("Successfully deactivated.", {
                    title: "Success"
                  });
                }
                _context13.next = 7;
                return _this12.getAll();

              case 7:
                _context13.next = 12;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);

                if (_context13.t0.errors) {
                  for (index = 0; index < _context13.t0.errors.length; index++) {
                    _this12.$notification.error(_context13.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context13.prev = 12;

                _this12.isLoading = false;
                return _context13.finish(12);

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this12, [[0, 9, 12, 15]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                _this13.isLoading = true;
                _context14.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_customer_customerService_js__["a" /* default */].delete(_this13.itemToBeDeleted.id);

              case 4:
                _this13.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context14.next = 7;
                return _this13.getAll();

              case 7:
                _context14.next = 12;
                break;

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14["catch"](0);

                if (_context14.t0.errors) {
                  for (index = 0; index < _context14.t0.errors.length; index++) {
                    _this13.$notification.error(_context14.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context14.prev = 12;

                _this13.isLoading = false;
                return _context14.finish(12);

              case 15:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this13, [[0, 9, 12, 15]]);
      }))();
    },
    printPhone: function printPhone(item) {
      return item && item.length > 0 ? "(+" + item[0].code + ") " + item[0].number : "N/A";
    },
    printEmail: function printEmail(item) {
      return item && item.length > 0 ? "" + item[0].email : "N/A";
    },
    addPhone: function addPhone() {
      this.model.modifiedPhones.push({
        id: this.$helper.emptyGuid(),
        code: null,
        number: null,
        isMain: false,
        state: "Created"
      });
    },
    removePhone: function removePhone(index) {
      this.model.modifiedPhones[index].state = "Deleted";
    },
    addEmail: function addEmail() {
      this.model.modifiedEmails.push({
        id: this.$helper.emptyGuid(),
        email: null,
        isMain: false,
        state: "Created"
      });
    },
    removeEmail: function removeEmail(index) {
      this.model.modifiedEmails[index].state = "Deleted";
    },
    onChangeCustomerItem: function onChangeCustomerItem(item) {
      if (item.id === this.$helper.emptyGuid()) {
        item.state = "Created";
      } else {
        item.state = "Updated";
      }
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/40.fddd184b0f35367f890a.js